<template>
  <section id="partner-order">
    <div class="po-top-container">
      <div class="po-header-container">
        <div class="header">
          Partner Orders
        </div>
        <SelectedPartner />
      </div>
    </div>
    <div class="po-body-container">
      <div class="po-content-container">
        <PartnerOrderTable />
      </div>
    </div>
  </section>
</template>

<script>
import partnerOrderMixin from '@shared/mixins/partnerOrderMixin';
import PartnerOrderTable from '@shared/components/partnerOrder/PartnerOrderTable.vue';
import adminMixin from '@shared/mixins/adminMixin';
import SelectedPartner from '@shared/components/admin/SelectedPartner.vue';

export default {
  name: 'PartnerOrder',
  metaInfo: {
    title: 'SmartAC.com | Partner Orders',
  },
  components: {
    SelectedPartner,
    PartnerOrderTable,
  },
  mixins: [adminMixin, partnerOrderMixin],
  watch: {
    selectedCorpId() {
      this.$store.dispatch('getOrdersForPartner');
    },
  },
  async mounted() {
    await this.$store.dispatch('getOrdersForPartner');
  },
};
</script>

<style lang="scss">

section#partner-order {
  @include section-container;

  .po-top-container {
    @include section-top-container;

    .po-header-container {
      @include section-header-container;

      .header {
        @include section-header;
      }

      .sub-header {
        font-size: 0.875rem;
        font-weight: 500;
        color: $N60;
      }
    }
  }

  .po-body-container {
    @include section-body-container;

    .po-content-container {
      @include section-content-container;
    }
  }
}
</style>
